import { gloryLightTheme, bangerTheme, UiKitTheme } from "@ui-kit-casino/theme";

export const getTheme = (projectName: string): UiKitTheme => {
  const themes = {
    glory: gloryLightTheme,
    banger: bangerTheme,
  };

  return themes[projectName];
};
